import { useContext, useState } from "react";
import { Table } from "react-bootstrap";
import { ShrinkHeader } from "../../../Table/ShrinkHeader";
import LoadingSpinner from "../../../Loading/LoadingSpinner";
import { TableContainer } from "../../../../@ui/TableContainer";
import { Button } from "react-bootstrap";
import styled from "styled-components";
import { LayerContext } from "../LayerContext";
import { OSHighwayInfo } from "../../../../types/OSHighwayFileSummary/OSHighwayInfo";
import { HighwaysVersionState } from "../../../../constant/HighwaysVersionState";
import { useOSHighwaysService } from "../../../../hooks";

const RejectButton = styled(Button)`
  background-color: #ff4d4d;
  border-color: #ff4d4d;
  color: white;
  border-color: #ff4d4d;
  padding: 0.2rem 0.4rem;
  &:hover,
  &:focus,
  &:active {
    background-color: #ff8080 !important;
    border-color: #ff8080 !important;
  }

  transition: all 0.3s ease;
`;

const ApproveButton = styled(Button)`
  background-color: white;
  border-color: #c1efd2;
  color: black;
  background-color: white;
  border-color: #c1efd2;
  padding: 0.2rem 0.4rem;

  &:hover,
  &:focus,
  &:active {
    background-color: #c1efd2 !important;
    color: black !important;
    border-color: #c1efd2 !important;
  }
  transition: all 0.3s ease;
`;

const OSHighwaysAction = () => {
  const value = useContext(LayerContext);
  const { layerInfo, setLayerInfo, layerAdminService } = value!;
  const osHighwayInfo = layerInfo as OSHighwayInfo;
  const osHighwaysActionService = useOSHighwaysService();
  const [loading, setLoading] = useState(false);

  const onApprove = (versionId: number) => {
    setLoading(true);
    osHighwaysActionService
      .Approve(versionId)
      .then(() => {
        layerAdminService.getLayerInfo("OS:Highways").then(setLayerInfo);
        setLoading(false);
      })
      .catch(() => {});
  };

  const onReject = (versionId: number) => {
    setLoading(true);
    osHighwaysActionService
      .Reject(versionId)
      .then(() => {
        layerAdminService.getLayerInfo("OS:Highways").then(setLayerInfo);
        setLoading(false);
      })
      .catch(() => {});
  };

  return (
    <>
      <TableContainer>
        <Table striped bordered hover>
          <thead>
            <tr>
              {/* <th className="p-2 text-white bg-primary">Highways Version</th> */}
              <th className="p-2 text-white bg-primary">Publication Date</th>
              <th className="p-2 text-white bg-primary">
                Total Files Received
              </th>
              {osHighwayInfo && osHighwayInfo.highwaysVersion && !loading && (
                <>
                  <ShrinkHeader className="p-2 text-white bg-primary"></ShrinkHeader>
                  <ShrinkHeader className="p-2 text-white bg-primary"></ShrinkHeader>
                </>
              )}
            </tr>
          </thead>
          <tbody>
            {osHighwayInfo && osHighwayInfo.highwaysVersion && !loading && (
              <>
                <tr>
                  {/* <td>{osHighwayInfo.highwaysVersion.versionId}</td> */}
                  <td>
                    {osHighwayInfo.highwaysVersion.publicationDate
                      .split("_")
                      .pop()}
                  </td>
                  <td>{osHighwayInfo.highwaysVersion.totalFilesReceived}</td>
                  <td className="text-center">
                    <ApproveButton
                      disabled={
                        osHighwayInfo.highwaysVersion.state !==
                        HighwaysVersionState.IMPORTED
                      }
                      onClick={() =>
                        onApprove(osHighwayInfo.highwaysVersion.versionId)
                      }>
                      Approve
                    </ApproveButton>
                  </td>
                  <td>
                    <RejectButton
                      disabled={
                        osHighwayInfo.highwaysVersion.state ===
                        HighwaysVersionState.APPROVED
                      }
                      onClick={() =>
                        onReject(osHighwayInfo.highwaysVersion.versionId)
                      }>
                      Reject
                    </RejectButton>
                  </td>
                </tr>
              </>
            )}
            {!osHighwayInfo?.highwaysVersion && (
              <>
                <tr>
                  <td colSpan={6} className="text-center">
                    No records found.
                  </td>
                </tr>
              </>
            )}
          </tbody>
        </Table>
      </TableContainer>

      {loading && <LoadingSpinner />}
    </>
  );
};
export default OSHighwaysAction;
